/*
 * ProjectsList Messages
 *
 * This contains all the text for the ProjectsList component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Courseware',
  },
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Courseware',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Courseware',
  },
  newProject: {
    id: `${scope}.newProject`,
    defaultMessage: 'New Project',
  },
  emptyPageTitle: {
    id: `${scope}.emptyPageTitle`,
    defaultMessage: 'Create with projects',
  },
  emptyPageDescription: {
    id: `${scope}.emptyPageDescription`,
    defaultMessage: 'Organise your content in one place with a new project folder.',
  },
  emptyPageLinkText: {
    id: `${scope}.emptyPageLinkText`,
    defaultMessage: 'How to use projects',
  },
  emptyPageButtonText: {
    id: `${scope}.emptyPageButtonText`,
    defaultMessage: 'Create Project',
  },
});
